import {
  ComputedRef,
  inject,
  InjectionKey,
  MaybeRefOrGetter,
  provide,
  ShallowRef,
} from "vue";

import { Navigator } from "./types";
import { NavigatorHistory } from "./history";

const navigatorSymbol = Symbol("navigator") as InjectionKey<
  Readonly<ShallowRef<Navigator>>
>;

const navigatorHistorySymbol = Symbol(
  "navigatorHistory"
) as InjectionKey<NavigatorHistory>;

export function provideNavigator(navigator: Readonly<ShallowRef<Navigator>>) {
  provide(navigatorSymbol, navigator);
  provide(navigatorHistorySymbol, new NavigatorHistory(navigator));
}

export function useNavigator(): MaybeRefOrGetter<Navigator> {
  return inject(navigatorSymbol) as ComputedRef<Navigator>;
}

export function useNavigatorWithHistory(): NavigatorHistory {
  return inject(navigatorHistorySymbol);
}
